/**
 * API URL Configuration
 * 
 * ALWAYS uses same-origin API calls (window.location.origin).
 * This ensures the app works on ANY deployed domain without configuration.
 * 
 * The frontend and backend are served from the same domain, so we always
 * use relative URLs that hit the same origin.
 */

export const getBackendUrl = () => {
  // ALWAYS use current origin - works on any domain (preview, custom, localhost)
  return window.location.origin;
};

export const getApiUrl = () => `${getBackendUrl()}/api`;

// Export for use in components that need the full backend URL (for file URLs)
export const BACKEND_URL = getBackendUrl();
export const API_URL = getApiUrl();
